import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Check, AlertCircle, Loader2 } from 'lucide-react';
import { useTranslation } from '../../context/LanguageContext';

const API = 'https://apicabaza.creago.be/rest/cabaza/contacts';

/**
 * Page ouverte depuis le lien « Ne plus recevoir d'invitations Cabaza » d'un e-mail d'invitation.
 * Publique : le jeton de l'invitation, dans l'adresse, fait foi. L'inscription à la liste d'exclusion
 * se fait par un POST (et non au simple chargement d'un lien que l'antivirus d'une messagerie peut ouvrir).
 */
const InvitationOptOutPage = () => {
    const { token } = useParams();
    const { t } = useTranslation();
    const l = t.invitationOptOut || {};
    const [etat, setEtat] = useState('chargement');

    useEffect(() => {
        let annule = false;
        (async () => {
            try {
                const reponse = await fetch(`${API}/invitation-optout/${encodeURIComponent(token)}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: '{}'
                });
                const result = await reponse.json();
                if (!annule) setEtat((result.success ?? result.SUCCESS) ? 'fait' : 'invalide');
            } catch {
                if (!annule) setEtat('invalide');
            }
        })();
        return () => { annule = true; };
    }, [token]);

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-lg overflow-hidden text-center">
                <div className="bg-gradient-to-r from-cabaza-purple to-cabaza-pink text-white text-2xl font-extrabold py-5">Cabaza</div>
                <div className="p-8 space-y-3" data-testid="invitation-optout">
                    {etat === 'chargement' && <Loader2 className="w-8 h-8 mx-auto animate-spin text-gray-400" />}
                    {etat === 'fait' && (
                        <>
                            <Check className="w-10 h-10 mx-auto text-emerald-600" />
                            <p className="text-gray-800">{l.done}</p>
                        </>
                    )}
                    {etat === 'invalide' && (
                        <>
                            <AlertCircle className="w-10 h-10 mx-auto text-amber-600" />
                            <p className="text-gray-800">{l.invalid}</p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InvitationOptOutPage;
